import axiosRequest from "@/utils/axios-utils";

export const getProductBySku = async (sku, token) => {
  const config = {
    method: "get",
    url: `/search/get-product-by-sku?sku=${sku}`,
    // url: `/search/get-product-by-sku?sku=0214223035`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getActivePdpDetails = async (token) => {
  const config = {
    method: "get",
    url: "/pdp/get-active-pdp-details",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getProductIInfoBySku = async (sku, token) => {
  const config = {
    method: "get",
    url: `/product/getProductRelatedInfo/${sku}`,
    // url: `/search/get-product-by-sku?sku=0214223035`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req?.data;
  } catch (error) {
    return error;
  }
};

export const getImages360ViewBySku = async (sku, token) => {
  const config = {
    method: "get",
    url: `/product/get360RotationImage/${sku}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
